import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import local from './modules/local';
import device from './modules/devices';
import ports from './modules/ports';
import mqtt from './modules/mqtt';
import maker from './modules/maker';
// import ModuleList from './modules/userData.APP_TARGET';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    local,
    user,
    device,
    ports,
    mqtt,
    maker,
  },
});
